// eslint-disable-next-line
export enum ConnectwiseInstanceType {
  CLOUD = 'cloud',
  ON_PREMISES = 'on-premises',
}
